// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3kOR8","cell":"ColumnAccessor_cell__1r7wO","firstCellAccent":"ColumnAccessor_firstCellAccent__2bkG1"};